import { useEffect } from 'react';
import "./AttendanceHeader.scss";
import { initializeSignatureCanvas, saveSignatureImage } from '../../logic/signature.js';
import useAppHeader from '../../../../components/AppHeader/logic/useAppHeader';
import useAttendance from '../../logic/useAttendance';

function AttendanceHeader() {

    useEffect(() => {
        initializeSignatureCanvas(saveSignatureImage);
    }, []);
    const { handleToggle, isSignatureClickable, handleSaveSignature, isPresent, isStatusDisabled } = useAttendance();
    useEffect(() => {
        const canvas = document.getElementById("signatureCanvas");
        if (canvas) {
            if (!isSignatureClickable) {
                canvas.style.pointerEvents = "none";
            } else {
                canvas.style.pointerEvents = "auto";
            }
        }
    }, [isSignatureClickable]);

    return (
        <div className='attendance-header'>
            {/* <div className='left-side'>
                <div className="user-image">
                    <img src={`${process.env.REACT_APP_CORE_PATH}/images/trainer/person.jpg`} alt="person" className="user-image" />
                </div>
                <div className="user-name">
                    <label>{authenticatedUser ? authenticatedUser.firstName : 'User'}</label>
                </div>
            </div> */}
            <div className='right-side'>
                <div className="presence">
                    <div className="presence-status">
                        <label>{isPresent ? "Present" : "Absent"}</label>
                    </div>
                    <label className="toggle">
                        <input type="checkbox" onClick={(e) => handleToggle(e)} disabled={isStatusDisabled} />
                        <span className="slider"></span>
                    </label>
                </div>
                <div className="signature-container">
                    <canvas id="signatureCanvas" width="180" height="60" disabled={!isSignatureClickable}></canvas>
                    <div className='sign-buttons'>
                        <button id="saveButton" onClick={handleSaveSignature} >Save</button>
                        <button id="clearButton">Clear</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AttendanceHeader;
